module.exports = __webpack_public_path__ + "img/img-sagaming-d.8e69c058.png";